import React from "react";
import { MessageCircle, Twitch, Twitter, Youtube } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer({ discordUrl }) {
  return (
    <footer className="border-t border-white/5 bg-black/60 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-6 py-10 grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2.5 mb-3">
            <img
              src="/brand/logo.png"
              alt="Spicy Community"
              data-testid="footer-logo"
              className="h-9 w-9 rounded-full object-cover ring-1 ring-red-500/40 shadow-[0_0_18px_rgba(230,0,0,0.5)]"
            />
            <span className="font-display font-extrabold text-lg">
              SPICY<span className="text-red-500">.</span>COMMUNITY
            </span>
          </div>
          <p className="text-sm text-zinc-500 max-w-xs">
            Premium competitive gaming community running elite tournaments and live brackets.
          </p>
        </div>
        <div>
          <div className="font-display font-semibold mb-3 text-sm uppercase tracking-widest text-zinc-400">
            Platform
          </div>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><a href="/" className="hover:text-white">Home</a></li>
            <li><a href="/tournaments" className="hover:text-white">Tournaments</a></li>
            <li><a href="/teams" className="hover:text-white">Teams</a></li>
            <li><a href="/leaderboard" className="hover:text-white">Leaderboard</a></li>
            <li><a href="/hall-of-fame" className="hover:text-white">Hall of Fame</a></li>
          </ul>
        </div>
        <div>
          <div className="font-display font-semibold mb-3 text-sm uppercase tracking-widest text-zinc-400">
            Community
          </div>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><a href={discordUrl} target="_blank" rel="noreferrer" className="hover:text-white">Discord</a></li>
            <li><Link to="/code-of-conduct" className="hover:text-white" data-testid="footer-conduct">Code of Conduct</Link></li>
            <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms</Link></li>
            <li><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-display font-semibold mb-3 text-sm uppercase tracking-widest text-zinc-400">
            Follow
          </div>
          <div className="flex items-center gap-3">
            {[MessageCircle, Twitter, Youtube, Twitch].map((Icon, i) => (
              <a
                key={i}
                href={discordUrl}
                target="_blank"
                rel="noreferrer"
                className="h-9 w-9 rounded-full glass-dark flex items-center justify-center hover:border-red-500/50 hover:text-red-400 transition-all"
              >
                <Icon size={14} />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 py-4 text-center text-xs text-zinc-600 font-mono">
        © {new Date().getFullYear()} Spicy Community. All rights reserved.
      </div>
    </footer>
  );
}
